import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import Settings from "./Settings";
import firebase from "../../firebase";
import AddNotice from "./AddNotice";
import emailjs from "emailjs-com";
import Header from "../Header";
import "../../table.css";
import Loader from "react-spinners/ClipLoader";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Feedback from "./feedback";

const AdminHome = (props) => {
  const [loading, setLoading] = useState(true);
  const [visi, setVisi] = useState(false);
  const [user, setUser] = useState([]);
  useEffect(() => {
    firebase
      .firestore()
      .collection("user")
      .orderBy("state", "asc")
      .onSnapshot((snapshot) =>
        setUser(snapshot.docs.map((doc) => doc.data()))
      );
    setLoading(false);
  }, []);
  const count = Object.keys(user).length;
  const [sended, setSended] = useState(false);
  const sendNotice = (e) => {
    e.preventDefault();
    firebase.firestore().collection("noti").doc(e.target.subject).set(e.target);
    emailjs
      .sendForm(
        "service_fed3346",
        "template_k3ewc41",
        e.target,
        "user_2qNETUG5Dtqv2M3G6vC8J"
      )
      .then(
        () => {
          setSended(true);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div>
      <Router>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <h1>Loading</h1>
            <Loader loading={loading} color={`#4285f4`} size={150} />{" "}
          </div>
        ) : (
          <div>
            <Header setSec={props.setSec} />
            <Switch>
              <Route exact path="/feedbackview">
                <Feedback />
              </Route>
              <Route exact path="/settings">
                <Settings />
              </Route>
              <Route>
                <div className="admin">
                  <div className="head2">
                    <ReactHTMLTableToExcel
                      className="btn"
                      table="delegates"
                      filename="delegates"
                      sheet="Sheet"
                      buttonText="Export excel"
                    />
                    <p style={{ textAlign: "right" }}>
                      Total Delegates: {count}
                    </p>
                  </div>
                  <table
                    id="delegates"
                    style={{ width: "100%", textAlign: "center" }}
                  >
                    <thead>
                      <tr>
                        <th>Full Name</th>
                        <th>Designation</th>
                        <th>E-mail</th>
                        <th>College</th>
                        <th>State</th>
                      </tr>
                    </thead>
                    <tbody>
                      {user.map(({ name, email, sec, coll, state, dege }) => (
                        <tr key={sec}>
                          <td>{name}</td>
                          <td>{dege}</td>
                          <td style={{ wordWrap: "break-word" }}>{email}</td>
                          <td style={{ wordWrap: "break-word" }}>{coll}</td>
                          <td>{state}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Route>
            </Switch>
            {visi ? (
              <AddNotice close={setVisi}>
                <form onSubmit={sendNotice}>
                  {user.map(({ email }) => (
                    <input
                      key={email}
                      type="hidden"
                      name="email"
                      value={email}
                    />
                  ))}
                  <input
                    className="noti"
                    name="subject"
                    type="text"
                    placeholder="Subject"
                  />
                  <br />
                  <textarea
                    className="noti"
                    name="message"
                    placeholder="Message"
                  ></textarea>
                  <br />
                  <button className="noti" type="submit">
                    Send Notice
                  </button>
                  {sended ? "Sended" : ""}
                </form>
              </AddNotice>
            ) : (
              ""
            )}
            <footer>
              <Link to="/">
                <img src="/user.png" alt="users" />
              </Link>
              <Link to="/feedbackview">
                <img
                  src="https://img.icons8.com/ios/50/000000/feedback.png"
                  alt="feedback"
                />
              </Link>
              <img
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setVisi(true);
                }}
                src="/notice.png"
                alt="notice"
              />
              <Link to="settings">
                <img src="sett.svg" alt="settings" />
              </Link>
            </footer>
          </div>
        )}
      </Router>
    </div>
  );
};

export default AdminHome;
